import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="mt-12 text-center">
      {/* Support Information */}
      <div className="bg-surface border border-border rounded-lg p-4 mb-6">
        <h3 className="text-sm font-medium text-text-primary mb-2">
          Need Help?
        </h3>
        <div className="flex items-center justify-center space-x-6 text-sm text-text-muted">
          <div className="flex items-center space-x-1">
            <Icon name="Phone" size={14} />
            <span>+1 (555) 123-4567</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Mail" size={14} />
            <span>support@nfcadmin.com</span>
          </div>
        </div>
      </div>

      {/* System Status */}
      <div className="flex items-center justify-center space-x-4 mb-6">
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
          <span className="text-sm text-text-muted">All Systems Operational</span>
        </div>
        <div className="w-1 h-1 bg-text-muted rounded-full"></div>
        <div className="flex items-center space-x-2">
          <Icon name="Globe" size={14} className="text-text-muted" />
          <span className="text-sm text-text-muted">Global Access</span>
        </div>
      </div>

      {/* Legal Links */}
      <div className="flex items-center justify-center space-x-6 mb-6 text-sm">
        <button className="text-text-muted hover:text-text-primary transition-colors duration-150">
          Privacy Policy
        </button>
        <div className="w-1 h-1 bg-text-muted rounded-full"></div>
        <button className="text-text-muted hover:text-text-primary transition-colors duration-150">
          Terms of Service
        </button>
        <div className="w-1 h-1 bg-text-muted rounded-full"></div>
        <button className="text-text-muted hover:text-text-primary transition-colors duration-150">
          Security
        </button>
      </div>

      {/* Copyright */}
      <div className="border-t border-border pt-6">
        <p className="text-text-muted text-sm">
          © {currentYear} NFC Card Admin. All rights reserved.
        </p>
        <p className="text-text-muted text-xs mt-1">
          Version 2.1.0 • Built with React & Tailwind CSS
        </p>
      </div>

      {/* Browser Compatibility Notice */}
      <div className="mt-4 text-xs text-text-muted">
        <p>Best viewed in Chrome, Firefox, Safari, or Edge</p>
      </div>
    </div>
  );
};

export default LoginFooter;